var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDuplicateOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-2 4",
    clipPath: "url(#clip0_2706_8218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.59716V13.1943H0.597156H1.19431V7.19431V1.19431H7.19431H13.1943V0.597156V0H6.59716H0V6.59716ZM2.96999 2.96999C2.96303 2.97693 2.95735 5.91153 2.95735 9.49132V16H9.47867H16V9.47867V2.95735H9.49132C5.91153 2.95735 2.97693 2.96303 2.96999 2.96999ZM4.15166 9.47867V14.8057H9.47867H14.8057V9.47867V4.15166H9.47867H4.15166V9.47867ZM8.891 7.70616V8.891H7.70616H6.52133V9.48815V10.0853H7.70616H8.891V11.2704V12.4555L9.48341 12.4505L10.0758 12.4455L10.0807 11.2656L10.0856 10.0856L11.2656 10.0807L12.4455 10.0758L12.4505 9.48341L12.4555 8.891H11.2704H10.0853V7.70616V6.52133H9.48815H8.891V7.70616Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706_8218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicateOutline);
export default __webpack_public_path__ + "static/media/icon--duplicate-outline.9d91a17063b787ef5288e4ca3599dc99.svg";
export { ForwardRef as ReactComponent };